import { useApp } from '@/hooks/useApp'
import type { AxiosError } from 'axios'
import type {
  Offer,
  WizardPropertyAdditionalData as Step4FormValues,
} from 'BrokerTsLib/src/dtos'
import { useContext, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { Container } from '../../../components/Container'
import { Loading } from '../../../components/Loading'
import { Section } from '../../../components/Section'
import { Steps } from '../../../components/Steps'
import WizardForbiddenMessage from '../../../components/WizardForbiddenMessage'
import { Step4Form } from '../../../containers/chaloupka/Step4Form'
import { InsuranceInfo } from '../../../containers/InsuranceInfo'
import { StepsContent } from '../../../context/StepsContext'
import { useGetOffer } from '../../../hooks/useOffer'
import { useSaveStep4, useUpdateLastWizardStep } from '../../../hooks/useWizard'
import { insuranceParamsContext } from '../../../layouts/Wizard'
import { Step4Context } from '../../carkulka/wizard/4'
export { Step4Context } from '../../carkulka/wizard/4'

export const Step4 = () => {
  const { product, setProduct } = useApp()
  const navigate = useNavigate()

  const {
    insuranceParams,
    insuranceParamsId,
    refetchInsuranceParams,
    isLoading,
  } = useContext(insuranceParamsContext)
  const { mutateAsync: saveStep4Async } = useSaveStep4()
  const { mutateAsync: updateStep } = useUpdateLastWizardStep()

  const offerId = insuranceParams?.generalParams.selectedOfferId
  const { data: axiosOffer } = useGetOffer(offerId ?? 0, {
    enabled: !!offerId,
    cacheTime: 0,
  })
  const offer = axiosOffer?.data ?? ({} as Offer)

  useEffect(() => {
    if (insuranceParams?.generalParams?.insuranceCategoryType)
      setProduct(insuranceParams?.generalParams?.insuranceCategoryType)
  }, [insuranceParams?.generalParams?.insuranceCategoryType])

  useEffect(() => {
    if (
      !isLoading &&
      insuranceParams &&
      (insuranceParams.generalParams?.lastWizardStep ?? 1) < 3
    )
      navigate('/chaloupka/wizard/too-far', { replace: true })

    if (
      !isLoading &&
      insuranceParams &&
      !insuranceParams.generalParams.selectedOfferId
    )
      navigate(`/chaloupka/wizard/3/${insuranceParamsId}`, { replace: true })
  }, [isLoading, insuranceParams])

  const handleSubmit = (values: Step4FormValues) => {
    return new Promise((resolve, reject) =>
      saveStep4Async(values)
        .then((response) => {
          if (values.nextPage == 'next') {
            if ((insuranceParams?.generalParams.lastWizardStep ?? 4) < 5) {
              updateStep({
                paramsId: Number(insuranceParamsId),
                step: 5,
                stepsStep: 'chaloupka',
              }).then(() => {
                refetchInsuranceParams().then(() => {
                  navigate(`/chaloupka/wizard/5/${insuranceParamsId}`)
                })
              })
            } else {
              refetchInsuranceParams().then(() => {
                navigate(`/chaloupka/wizard/5/${insuranceParamsId}`)
              })
            }
          } else {
            window.scrollTo(0, 0)
          }

          resolve(response)
        })
        .catch((err: AxiosError) => {
          if (
            !(err.response && err.response.status === 400 && err.response.data)
          )
            return

          reject(err)
        })
        .finally(() => { }),
    )
  }

  return (
    <Step4Context.Provider value={{ offer: offer! }}>
      <Section>
        <Container>
          {isLoading && <Loading large={true} />}

          {(!insuranceParamsId || insuranceParams && product == insuranceParams.generalParams.insuranceCategoryType) && !isLoading &&
            <StepsContent step={4}>
              <Steps icon="house" />

              <InsuranceInfo />

              <Step4Form onSubmit={handleSubmit} />

            </StepsContent>
          }
        </Container>

        <WizardForbiddenMessage />
      </Section>
    </Step4Context.Provider>
  )
}
